export default __webpack_public_path__ + "static/media/circle.19fab9e4.svg";